import { Box, type BoxProps } from "@chakra-ui/react";
import { TokenMultichain } from "@components/Token";
import { ChainNamespaces, getChainFullIdFromNetwork } from "@umami/chains";
import {
  useCurrentAccount,
  useGetSaplingAccount,
  useGetTokensAndBalances,
  useSelectedNetwork,
} from "@umami/state";

type ShieldedBalanceProps = {
  hasSendButton?: boolean;
  padding?: string;
  onClick?: () => void;
} & Omit<BoxProps, "onClick">;

export const ShieldedBalance = ({
  hasSendButton = false,
  padding,
  onClick,
  ...boxProps
}: ShieldedBalanceProps) => {
  const { balances } = useGetTokensAndBalances();
  const currentAccount = useCurrentAccount();
  const network = useSelectedNetwork();
  const saplingAccount = useGetSaplingAccount(currentAccount?.address.pkh ?? "");

  // Calculate Shielded Balance data
  const shieldedBalance = saplingAccount?.balance ? Number(saplingAccount.balance) : 0;

  const tezosBalance = balances.find(balance => balance.chainId.includes(ChainNamespaces.TEZOS));
  const tezosUsdPrice = tezosBalance?.usdPrice ?? 0;
  const shieldedUsdBalance = shieldedBalance * tezosUsdPrice;
  const tokenMultichain = (
    <TokenMultichain
      padding={padding}
      balance={shieldedBalance}
      chain={getChainFullIdFromNetwork(network)}
      data-testid="shielded-balance"
      hasSendButton={hasSendButton}
      hasUnshieldButton={true}
      isShieldedBalance
      name="XTZ"
      usdBalance={shieldedUsdBalance}
      usdPrice={tezosUsdPrice}
    />
  );

  if (onClick) {
    return (
      <Box width="full" onClick={onClick} {...boxProps}>
        {tokenMultichain}
      </Box>
    );
  }

  return tokenMultichain;
};
